import React, { useEffect, useState } from 'react';
import { Container, DateRangeWrapper, Wrapper, Row, DateInput, DateTitle, SaveButton } from './styled';
import  DatePicker  from 'react-datepicker';
import { pt } from 'date-fns/locale';
import Button from '../../ReUsableComponents/Button';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {dateRevisao2DatesUpdate} from '../../../../../Services/cardService';

const DataRevisao2Popover = (props) => {
	const dispatch = useDispatch();
	const card = useSelector((state) => state.card);

	const [dateRevisao2, setdateRevisao2] = useState(
		card.dateRevisao2 ? moment(card.dateRevisao2).toDate():null
	);

	useEffect(() => {
		// Atualiza o estado quando o card.dateEntrega mudar
		if (card.dateRevisao2) {
			setdateRevisao2(moment(card.dateRevisao2).toDate());
		}
	}, [card.dateRevisao2]);
	
	const handleSaveClick = async () => {
		props.closeCallback();
		await dateRevisao2DatesUpdate(
			card.cardId,
			card.listId,
			card.boardId,
			dateRevisao2 ? moment(dateRevisao2).format('YYYY-MM-DD') : null,
			dispatch
		);
	};

	const handleRemoveClick = async () => {
		props.closeCallback();
		await dateRevisao2DatesUpdate(card.cardId, card.listId, card.boardId, null, dispatch);
	};


	return (
		<Container>
			<DateRangeWrapper>
				<DatePicker
					selected={dateRevisao2}
					onChange={(date) => setdateRevisao2(date)}
					dateFormat="dd/MM/yyyy"
					locale={pt}					
					placeholderText="Selecione uma data"
					inline // Mantém o calendário visível				
				/>
			</DateRangeWrapper>
			<Wrapper>
				<DateTitle>Data de Entrega</DateTitle>
				<Row>					
					<DateInput						
						value={dateRevisao2 ? moment(dateRevisao2).format('DD/MM/YYYY') : ''}						
					/>
				</Row>
				<SaveButton onClick={handleSaveClick}>Salvar</SaveButton>
				<Button clickCallback={handleRemoveClick} title="Remover" />
			</Wrapper>
		</Container>
	);
};

export default DataRevisao2Popover;
